import { Fragment, useState } from 'react'
import { NavLink } from "react-router-dom";
import { Popover, Transition } from '@headlessui/react'
import { AnimatePresence, motion } from 'framer-motion'
import { NavLinks } from '../common/nav-links'
import { useTranslation } from "react-i18next";
import { supportedLocalesSelect } from "../../i18n";
import { HashLink } from 'react-router-hash-link';

function classNames(...classes) {
    return classes.filter(Boolean).join(" ")
}


function MenuIcon(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
            <path
                d="M5 6h14M5 18h14M5 12h14"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function ChevronUpIcon(props) {
    return (



        <svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L31.5772 31.5772" stroke="white" stroke-width="6.5" stroke-linecap="round" />
            <path d="M4 32L31.5772 4.42284" stroke="white" stroke-width="6.5" stroke-linecap="round" />
        </svg>

    )
}

function MobileNavLink({ children, ...props }) {
    return (
        <HashLink
            to={props.href}
            className="block text-sm leading-7 tracking-wide text-white uppercase"
            {...props}
        >
            {children}
        </HashLink>
    )
}

export function Navigation({ siteConfig, isFixed = false, isDark = false, isBlur = false }) {


    const [isActiveMobileMenu, setActiveMobileMenu] = useState(false);


    return (
        <header className={classNames(
            isDark ? "" : "",
            isFixed ? 'border-b border-gray-200 bg-[#3c86a7b3] ' : "sticky top-0 z-40 w-full flex-none duration-500 lg:z-50",
            isBlur ? 'duration-500  backdrop-blur transition-colors duration-500  lg:bg-[#3c86a7b3] dark:bg-[#3c86a7b3] bg-[#3c86a7b3] supports-backdrop-blur:bg-[#3c86a7b3]' : ""
        )}

        >
            <nav>
                <div className="mx-auto max-w-7xl py-4 px-4 sm:px-6 lg:px-8 relative z-50 flex justify-between ">
                    <div className="relative z-10 flex items-center gap-16">
                        <NavLink to="/" >
                            <img src={(isDark && !isActiveMobileMenu) ? siteConfig?.general?.front_logo : siteConfig?.general?.front_logo} className="h-10 w-auto" alt="" />
                        </NavLink>
                        <div className="hidden lg:flex lg:gap-10">
                            <NavLinks siteConfig={siteConfig} isDark={isDark} />
                        </div>
                    </div>
                    <div className="flex items-center gap-6">
                        <LanguageSwitch />

                        <Popover className="lg:hidden items-center">
                            {({ open }) => {
                                setActiveMobileMenu(open);
                                return (
                                    <>
                                        <Popover.Button
                                            className={classNames(
                                                "relative z-10 -m-2 inline-flex items-center rounded-lg  p-2 ui-not-focus-visible:outline-none",
                                                (isDark && !isActiveMobileMenu) ? "stroke-white hover:bg-gray-200/50 hover:stroke-white active:stroke-gray-900 " : "stroke-gray-900 hover:bg-gray-200/50 hover:stroke-gray-600 active:stroke-gray-900 ",
                                            )}
                                            aria-label="Toggle site navigation"
                                        >
                                            {({ open }) =>
                                                open ? (
                                                    <ChevronUpIcon className="h-6 w-6" />
                                                ) : (
                                                    <MenuIcon className="h-6 w-6" />
                                                )
                                            }
                                        </Popover.Button>
                                        <AnimatePresence initial={false}>
                                            {open && (
                                                <>
                                                    <Popover.Overlay
                                                        static
                                                        as={motion.div}
                                                        initial={{ opacity: 0 }}
                                                        animate={{ opacity: 1 }}
                                                        exit={{ opacity: 0 }}
                                                        className="fixed inset-0 z-0 bg-gray-300/60 backdrop-blur"

                                                    />
                                                    <Popover.Panel
                                                        static
                                                        as={motion.div}
                                                        initial={{ opacity: 0, y: -32 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        exit={{
                                                            opacity: 0,
                                                            y: -32,
                                                            transition: { duration: 0.2 },
                                                        }}
                                                        className="absolute inset-x-0 top-0 z-0 origin-top rounded-b-2xl bg-gray-50 px-6 pb-6 pt-32 shadow-2xl shadow-gray-900/20"
                                                        style={{ backgroundColor: '#3C86A7' }}
                                                    >
                                                        <div className="space-y-3">
                                                            {
                                                                (siteConfig?.menus ?? []).map((data, index) => (
                                                                    <>
                                                                        {
                                                                            data.url && (
                                                                                <MobileNavLink key={data.id} href={data.url}>
                                                                                    {data.name}
                                                                                </MobileNavLink>
                                                                            )
                                                                        }


                                                                    </>
                                                                ))
                                                            }
                                                        </div>


                                                        <div className="mt-8 flex flex-col gap-4">

                                                        </div>
                                                    </Popover.Panel>
                                                </>
                                            )}
                                        </AnimatePresence>
                                    </>
                                )

                            }}
                        </Popover>






                    </div>
                </div>
            </nav>
        </header>
    )
}

const LanguageSwitch = () => {

    const { i18n } = useTranslation();
    const setLanguage = (e) => {
        const code = e.target.dataset.locale;
        i18n.changeLanguage(code);
    };


    return (
        <Popover className="inline-flex relative -mt-2 md:mt-0">
            <Popover.Button className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 lg:text-white text-grey-900 border-0 outline-0">
           

                {/* <img alt='' src={i18n.language.includes('en') ? enFlag : itFlag} className={'w-5 h-5'} /> */}

                 <div class="text-white border border-white-500/50 w-10 rounded-lg">{i18n.language.includes('en') ? 'EN' : 'IT'}</div>

                </Popover.Button>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
            >
                <Popover.Panel className="absolute  z-10 mt-8 flex w-screen -translate-x-10">
                    <div className="shrink rounded-sm py-2 px-4  text-sm font-semibold leading-6 bg-white text-gray-900">
                        {Object.entries(supportedLocalesSelect).map(
                            ([code, { nativeName }]) => (
                                (!i18n.language.includes(code)) && (
                                    <div className="flex items-center cursor-pointer" key={code} onClick={setLanguage}>
                                       
                                        <div
                                            data-locale={code}
                                            className={"block hover:text-main-100  text-grey-900"}
                                        >
                                            {nativeName}
                                        </div>
                                    </div>
                                )
                            )
                        )}


                    </div>





                </Popover.Panel>
            </Transition>
        </Popover>
    )
}
